export default __webpack_public_path__ + "b7e5eff152eb0febbfae3e8a735763023aac9455/953bf272c7159fa44f34a644a31a09c9.png";